import { PriceListViewModel } from '@/api/api';
import { Module } from 'vuex';
import { TypedModule } from '../utility/module-utility-types';
import { WebRootState } from '../web-root-state';
import { namespace } from 'vuex-class';

export const enum PriceState {
  stickerPriceList = 'stickerPriceList'
}

export interface PriceStateTypes {
  [PriceState.stickerPriceList]: PriceListViewModel[] | null;
}

export const enum PriceMutation {
  setStickerPriceList = 'setStickerPriceList'
}

export interface PriceMutationPayloadTypes {
  [PriceMutation.setStickerPriceList]: PriceListViewModel[] | null;
}

export const enum PriceAction {
  loadStickerPriceList = 'loadStickerPriceList'
}

export interface PriceActions {
  [PriceAction.loadStickerPriceList]: () => void;
}

export const enum PriceGetter {
  stickerPriceList = 'stickerPriceList'
}

export interface PriceGetterTypes {
  [PriceGetter.stickerPriceList]: PriceListViewModel[] | null;
}

export const PRICE_STATE_NAMESPACE = 'PriceState';
export const PriceNamespace = namespace(PRICE_STATE_NAMESPACE);

export type PriceModule = Override<
  Module<PriceStateTypes, WebRootState>,
  TypedModule<
    PriceStateTypes,
    PriceMutationPayloadTypes,
    PriceActions,
    PriceGetterTypes,
    WebRootState
  >
>;
